import { Api } from '@Services/api'

// Tipagens básicas conforme OpenAPI (podem ser refinadas depois)
export interface PipedriveListResponse<T = any> {
    success: boolean
    data: T
    additional_data?: any
}

export interface PipedriveSearchProductsResponse {
    success: boolean
    data: {
        items: Array<{ item: any }>
    }
}

export interface AddDealProductDto {
    product_id: number
    item_price: number
    quantity: number
}

class PipedriveAPI {
    private http = new Api()

    // GET /pipedrive/products
    async listProducts(params?: { start?: number; limit?: number }) {
        const { data } = await this.http.get('/pipedrive/products', { params })
        return data as PipedriveListResponse<any[]>
    }

    // GET /pipedrive/products/search
    async searchProducts(params: {
        term: string
        start?: number
        limit?: number
    }) {
        const { data } = await this.http.get('/pipedrive/products/search', {
            params,
        })
        return data as PipedriveSearchProductsResponse
    }

    // GET /pipedrive/deals/:id
    async getDeal(id: number) {
        const { data } = await this.http.get(`/pipedrive/deals/${id}`)
        return data as { success: boolean; data: any }
    }

    // POST /pipedrive/deals/:id/products
    async addDealProduct(id: number, payload: AddDealProductDto) {
        const { data } = await this.http.post(
            `/pipedrive/deals/${id}/products`,
            payload
        )
        return data
    }

    // PATCH /pipedrive/deals/:id/products/:productAttachmentId
    async updateDealProduct(
        id: number,
        productAttachmentId: number,
        payload: AddDealProductDto
    ) {
        const { data } = await this.http.patch(
            `/pipedrive/deals/${id}/products/${productAttachmentId}`,
            payload
        )
        return data
    }

    // DELETE /pipedrive/deals/:id/products/:productAttachmentId
    async removeDealProduct(id: number, productAttachmentId: number) {
        const { data } = await this.http.delete(
            `/pipedrive/deals/${id}/products/${productAttachmentId}`
        )
        return data
    }
}

export const pipedriveAPI = new PipedriveAPI()
